module.exports = __webpack_public_path__ + "static/media/confirm-btn@2x.86c5f65f.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_31/imgs/confirm-btn@2x.png
// module id = 328
// module chunks = 0